import React from 'react';
import { Lock, AlertTriangle } from 'lucide-react';
import { useSubscription } from '../context/SubscriptionContext';

const ReadOnlyBanner = ({ onUpgrade }) => {
  const { subscriptionStatus, isExpired } = useSubscription();
  
  if (!isExpired()) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-red-500 to-orange-600 text-white py-4 px-4 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Lock className="h-6 w-6" />
            <div>
              <div className="flex items-center space-x-2">
                <AlertTriangle className="h-5 w-5" />
                <span className="font-bold text-lg">Mode Lecture Seule</span>
              </div>
              <p className="text-sm text-white/90 mt-1">
                Votre période d'essai est terminée. Vous pouvez consulter vos données mais ne plus les modifier.
              </p>
            </div>
          </div>
          
          <button
            onClick={onUpgrade}
            className="bg-white text-red-600 px-6 py-2.5 rounded-lg font-bold hover:bg-red-50 transition-all hover:scale-105 shadow-lg"
          >
            🚀 Débloquer l'accès complet
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;
